import UrlPattern from 'url-pattern';
import { Language } from '../../lib/types';
import { AnswersSupportedLangs, ContentfulSupportedLangs } from './Languages';
import { renting, rentingOut } from './HowItWorksUrls';
import { PaymentsUrls } from './Payments';
import {
  globalReach,
  easyPropertyManagement,
  integrations,
  securePayments,
  superiorMatching,
  smartSearch,
  onlineViewing,
  directMessaging,
} from './Feature';

export const marketingPages = [
  renting,
  rentingOut,
  ...Object.values(PaymentsUrls),
  globalReach,
  easyPropertyManagement,
  integrations,
  securePayments,
  superiorMatching,
  smartSearch,
  onlineViewing,
  directMessaging,
];

const languageUrls = (lang: Language) => marketingPages.map(page => page[lang]);

export const getMarketingPageIndex = (slug: string, lang: Language) =>
  languageUrls(lang).indexOf(`/${slug}`);

export const getMarketingPageUrl = (pageIndex: number, lang: Language) =>
  languageUrls(lang)[pageIndex];

const getAnswersPageUrl = (link: string, lang: Language) => {
  const answersMatchPattern = new UrlPattern(
    '(http(s)\\://)answers.housinganywhere.:tld(/*)',
  );

  if (
    !AnswersSupportedLangs.includes(lang) ||
    !answersMatchPattern.match(link)
  ) {
    return undefined;
  }

  return link.replace(`/${Language.en}/`, `/${lang}/`);
};

export const getSubPageUrl = (link: string | undefined, lang: Language) => {
  const myMatchPattern = new UrlPattern('(/:lang/)my(/*)');
  if (
    !link ||
    ContentfulSupportedLangs.includes(lang) ||
    Boolean(myMatchPattern.match(link))
  ) {
    return link;
  }

  const answersPageUrl = getAnswersPageUrl(link, lang);
  if (answersPageUrl) {
    return answersPageUrl;
  }

  const pageIndex = getMarketingPageIndex(link, Language.en);
  if (pageIndex >= 0) {
    return getMarketingPageUrl(pageIndex, lang).substring(1);
  }

  return undefined;
};
